import {
  actions,
  getContentEntityTextAsync,
  addTextAsync,
  updateTextAsync,
  setDefaultTextAsync,
  removeTextAsync,
} from './slices';

export const ContentEntityTextsActions = {
  ...actions,
  getContentEntityTextAsync,
  addTextAsync,
  updateTextAsync,
  setDefaultTextAsync,
  removeTextAsync,
};
